
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const fetchLakersData = async () => {
    let scoreData = {
        is_live_data: false,
        match_status: null,
        is_break: false,
        lakers_data: []
    };

    // To check live data
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL_BALLDONTLIE}/box_scores/live`, {
            headers: {
                Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN,
            },
        });

        if (Array.isArray(response.data.data)) {
            scoreData.lakers_data = response.data.data.filter(game => game.home_team.name === "Lakers" || game.visitor_team.name === "Lakers");

            if (scoreData.lakers_data.length > 0) {

                if (scoreData.lakers_data[0].time != null && scoreData.lakers_data[0].time != "Final") {
                    scoreData.is_live_data = true;
                    scoreData.match_status = "live";

                    if (scoreData.lakers_data[0].home_team.players) {
                        scoreData.lakers_data[0].home_team.top_players = await getTopPlayers(scoreData.lakers_data[0].home_team);
                    }

                    if (scoreData.lakers_data[0].visitor_team.players) {
                        scoreData.lakers_data[0].visitor_team.top_players = await getTopPlayers(scoreData.lakers_data[0].visitor_team);
                    }

                    let gameStanding = await fetchTeamStanding(scoreData.lakers_data[0].season, scoreData.lakers_data[0].home_team.id, scoreData.lakers_data[0].visitor_team.id);

                    scoreData.lakers_data[0].visitor_team.standing = gameStanding.visitor_standing;
                    scoreData.lakers_data[0].home_team.standing = gameStanding.home_standing;


                    if (scoreData.lakers_data[0].time && scoreData.lakers_data[0].time.includes("END")) {
                        scoreData.lakers_data[0].status = scoreData.lakers_data[0].time;
                        scoreData.lakers_data[0].time = null;
                        scoreData.is_break = true;
                    }
                 
                    if (scoreData.lakers_data[0].time && scoreData.lakers_data[0].time === "Half") {
                        scoreData.lakers_data[0].time = null;
                        scoreData.lakers_data[0].status = "Half-Time";
                    }

                    return scoreData;
                }


                // To check live match if time is null just after match starts
                if (scoreData.lakers_data[0].time == null  && scoreData.lakers_data[0].period == 0) {
                    let currentTime = new Date();
                    let matchTime = new Date(scoreData.lakers_data[0].status);
                 
                    if (!isNaN(matchTime.getTime())) {

                        let timeDifference = currentTime - matchTime; 
                        let minutesDifference = timeDifference / (1000 * 60);
                        if (minutesDifference >= 0 && minutesDifference <= 18) {
                            scoreData.is_live_data = true;
                            scoreData.lakers_data[0].status = currentTime;
                            // scoreData.lakers_data[0].time = "About to Start";

                            let gameStanding = await fetchTeamStanding(scoreData.lakers_data[0].season,scoreData.lakers_data[0].home_team.id,scoreData.lakers_data[0].visitor_team.id);

                            scoreData.lakers_data[0].visitor_team.standing  = gameStanding.visitor_standing;
                            scoreData.lakers_data[0].home_team.standing  = gameStanding.home_standing;
        
                            return scoreData;

                        }

                    }

                }



                if (scoreData.lakers_data[0].period == 0 || scoreData.lakers_data[0].time == null) {

                    if (scoreData.lakers_data[0].status) {

                        let currentTime = new Date();
                        let matchTime = new Date(scoreData.lakers_data[0].status);
                        let timeDifference = matchTime - currentTime;
                        let hoursDifference = timeDifference / (1000 * 60 * 60);
                        if (hoursDifference < 2) {
                            scoreData.match_status = "upcoming";
                        } else {
                            scoreData.match_status = "next";
                        }

                    }

                }

                return scoreData;
            }

        } else {
            return scoreData;
        }

    } catch (error) {
        return scoreData;
    }


    return scoreData;
};

// End of check live data


// Function to get top 3 players
			
const getTopPlayers = async (team) => {
    if (team.players && team.players.length > 0) {
        const topPlayers = team.players
            .sort((a, b) => b.pts - a.pts)
            .slice(0, 3)
            .map(player => {
                const pointDetails = `AST(${player?.ast}), REB(${player?.reb}), STL(${player?.stl}), BLK(${player?.blk}), TO(${player?.turnover})`;
                const percentageDetails = `FG%(${player?.fg_pct.toFixed(2)}%), 3P%(${player?.fg3_pct.toFixed(2)}%), FT%(${player?.ft_pct.toFixed(2)}%)`;

                return {
                    name: `${player.player.first_name} ${player.player.last_name} (${player.pts}pts)`,
                    point_details: pointDetails,
                    percentage_details: percentageDetails,
                };
            });

        return topPlayers;
    } else {
        return [];
    }
}


const fetchTeamStanding = async (season, homeTeamId, visitorTeamId) => {
    let teamStandingData = {
        home_standing: null,
        visitor_standing: null,
    };

    const cacheKey = `teamStanding_${season}_${homeTeamId}_${visitorTeamId}`;
    const cachedData = sessionStorage.getItem(cacheKey);
    const currentTime = new Date().getTime();

    if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);
        if (currentTime - timestamp < 1000 * 60 * 10) {
            return data;
        }
    }

    try {
        const teamStandingResponse = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL_BALLDONTLIE}/standings?season=${season}`, {
            headers: {
                Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN,
            },
        });

        if (Array.isArray(teamStandingResponse.data.data)) {
            const filteredStandings = teamStandingResponse.data.data.filter(game =>
                game.team.id === homeTeamId || game.team.id === visitorTeamId
            );

            if (filteredStandings.length > 0) {
                for (const standing of filteredStandings) {
                    if (standing.team.id === homeTeamId) {
                        teamStandingData.home_standing = standing;
                    } else if (standing.team.id === visitorTeamId) {
                        teamStandingData.visitor_standing = standing;
                    }
                }
            }
        }

        sessionStorage.setItem(cacheKey, JSON.stringify({ data: teamStandingData, timestamp: currentTime }));

        return teamStandingData;

    } catch (error) {
        return teamStandingData;
    }
};




export const fetchBoxScores = createAsyncThunk(
    'boxScores/fetchBoxScores',
    async (date, { rejectWithValue }) => {
        try {
            const lakersScoreOldData = await fetchLakersData();
            return lakersScoreOldData;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
const boxScoresSlice = createSlice({
    name: 'boxScores',
    initialState: {
        preScores: [],
        preloading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBoxScores.pending, (state) => {
                state.preloading = true;
                state.error = null;
            })
            .addCase(fetchBoxScores.fulfilled, (state, action) => {
                state.preloading = false;
                state.preScores = action.payload;
            })
            .addCase(fetchBoxScores.rejected, (state, action) => {
                state.preloading = false;
                state.error = action.payload;
            });
    },
});

export default boxScoresSlice.reducer;